export default {
  undo(state) {
    state.undo.pop()
  },

  redo(state) {
    state.redo.pop()
  },

  pushToStack(state, { stack, action, params }) {
    state[stack].push({ action, params })
  },

  clearStack(state, stack) {
    if (stack) {
      state[stack] = []
    } else {
      state['undo'] = []
      state['redo'] = []
    }
  },

  hasUnsaveChanges(state, status) {
    state.hasUnsaveChanges = status
  },
}
